import React from 'react'
import styles from './getting-started.module.scss'
import { ReactComponent as CloseIcon } from 'assets/img/close.svg';
import { ReactComponent as BannerIcon } from 'assets/img/complete-list.svg';
import ReactModal from 'react-modal';
import { gettingStartedRightSideBarAtom } from 'showMessageMenuAtom';
import { useAtom } from 'jotai';
import SetupBoard from 'components/CommunityOnboardingComp/SetupBoard';

interface ICommunityOnboardingProps {
    groupData: any
    refreshGroupInformations: () => void
    courseExists: boolean
    OnboardingEmailsSet: boolean
    libraryContentExists: boolean
    workflowExists: boolean
    landingPagesExists: boolean
}


const AdminGettingStartedRighSideBar: React.FC<ICommunityOnboardingProps> = ({
    groupData,
    refreshGroupInformations,
    courseExists,
    OnboardingEmailsSet,
    libraryContentExists,
    workflowExists,
    landingPagesExists
}) => {
    const [isRightSideBarOpen, setIsRightSideBarOpen] = useAtom(gettingStartedRightSideBarAtom);

    const closeRightSideBar = () => {
        setIsRightSideBarOpen(false);
    }

    return (
        <ReactModal
            id='AdminGettingStartedRighSideBar'
            isOpen={isRightSideBarOpen}
            className={`${styles.modal} ${isRightSideBarOpen ? styles.modal_open : styles.modal_close}`}
            overlayClassName={styles.overlay}
            closeTimeoutMS={300} // Matches transition duration
        >
            <div
                className={styles.closeIcon}
                onClick={closeRightSideBar}
            >
                <CloseIcon />
            </div>
            <div className={styles.content}>
                <div className={styles.content__header}>
                    <GettingStartedBanner />
                </div>
                <SetupBoard
                    groupData={groupData}
                    refreshGroupInformations={refreshGroupInformations}
                    courseExists={courseExists}
                    OnboardingEmailsSet={OnboardingEmailsSet}
                    isPopup={true}
                    libraryContentExists={libraryContentExists}
                    workflowExists={workflowExists}
                    landingPagesExists={landingPagesExists}
                />
            </div>
        </ReactModal>
    )
}

const GettingStartedBanner = () => {
    return (
        <div className={styles.banner}>
            <h1>Video Training</h1>
            <BannerIcon />
        </div>
    )
}

export default AdminGettingStartedRighSideBar